import { NonEmptyString } from 'io-ts-types';
import {
    CompletionInfoForExecutionCreatedFromServiceOption,
    StartInfoForExecutionCreatedFromServiceOption,
} from '../../../serviceOrders/serviceOptions/serviceOrderCreationDetails.types';

import { mapToApiServiceType } from './serviceTypeMapper';
import {
    ApiServiceOptionCompletion,
    ApiServiceOptionStartInfo,
} from '../../types/serviceOrder/serviceOptionExecutionApi.types';

export const mapToApiStartInfoForExecutionCreatedFromServiceOption = (
    startInfo: StartInfoForExecutionCreatedFromServiceOption,
): ApiServiceOptionStartInfo => ({
    type: mapToApiServiceType(startInfo.service.type),
    description: startInfo.service.description as NonEmptyString,
    started_at: startInfo.startedAt.toISOString() as NonEmptyString,
    general_information: startInfo.generalInformation as NonEmptyString,
});

export const mapToApiCompletionInfoForExecutionCreatedFromServiceOption = (
    completion: CompletionInfoForExecutionCreatedFromServiceOption,
): ApiServiceOptionCompletion => ({
    type: mapToApiServiceType(completion.service.type),
    description: completion.service.description as NonEmptyString,
    started_at: completion.startedAt?.toISOString() as NonEmptyString | undefined,
    completed_at: completion.completedAt.toISOString() as NonEmptyString,
    general_information: completion.generalInformation as NonEmptyString,
});
